export enum ProductTypeTagging {
  AutoPay = 'autopay',
  Payment = 'regular',
}

export enum PaymentTypeTagging {
  CreditCard = 'creditcard',
  DebitCard = 'debit',
  Echeck = 'echeck',
}
